import {Component, inject, OnInit} from '@angular/core';
import {EnvironmentService} from '@services/environment/environment.service';
import {initSentry} from '@core/providers/sentry/sentry';
import {addGAScripts, GAEnums} from '@core/providers/ga/ga.provider';
import {MixpanelService} from '@services/mixpanel/mixpanel.service';
import {NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';

// tslint:disable-next-line:ban-types
// declare let gtag: Function;
declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

@Component({
  selector: 'oct-root',
  templateUrl: './app.component.html',
  standalone: false
})
export class AppComponent implements OnInit {
  private readonly _environmentService = inject(EnvironmentService);
  private readonly _mixpanelService = inject(MixpanelService);
  private readonly _router = inject(Router);

  region = this._mixpanelService.getUserRegion();

  constructor() {
    initSentry();
    this._mixpanelService.init();
  }

  ngOnInit() {
    addGAScripts(GAEnums[this._environmentService.env] || GAEnums.development).then(() => {});
    this._router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      if (window?.gtag) {
        window.gtag('config', GAEnums[this._environmentService.env] || GAEnums.development, {
          page_location: window.location.href,
          page_path: event.urlAfterRedirects,
          screen_class: event.urlAfterRedirects
        });
      }
    });
  }
}
